import { Link } from "react-router-dom";
import "../../styles/footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";


export const Footer = () => {

    return (
        <footer className="app-footer glassy-effect">
            <div className="f-child lg">
                <div className="f-logo">
                    <img
                        className="f-logo-img"
                        src="/logos/rwt.png"
                        alt=""
                        loading="lazy"
                    />
                    <div className="app-name">Random Walk Tech</div>
                </div>
                <div className="app-slogan f-text">
                    Pioneering the future of technology with AI-assisted solutions. We transform ideas into digital reality through innovative web development, mobile apps, stunning graphics, and robust cybersecurity.
                </div>
            </div>
            <div className="f-child f-service">
                <div className="list-caption">Services</div>
                <Link to={"services/web-development"} className="f-link">Web Development</Link>
                <Link to={"/services/mobile-development"} className="f-link">Mobile Development</Link>
                <Link to={"/services/graphics-design"} className="f-link">Graphics Design</Link>
                <Link to={"/services/cyber-security"} className="f-link">Cyber Security</Link>
            </div>
            <div className="f-child f-contact">
                <div className="list-caption">Contact</div>
                <div className="contact-unit">
                    <FontAwesomeIcon icon={faEnvelope} />
                    <div className="contact-text">info@randomwalktech.com</div>
                </div>
                <div className="contact-unit">
                    <FontAwesomeIcon icon={faPhone} />
                    <div className="contact-text">+(237) 678921882</div>
                </div>
                <div className="contact-unit">
                    <FontAwesomeIcon icon={faLocationDot} />
                    <div className="contact-text">Bafoussam, Cameroon</div>
                </div>
            </div>
        </footer>
    );
}